import { Injector } from '@angular/core';
import { GoogleAnalyticsService } from '@app/finxone-web-frontend/app/lib/services/google-analytics/google-analytic.service';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import {
  ActionButtonOutcomesType,
  BaseWidgetProperties,
  ButtonActionType,
  NavigationOptionEnum,
} from '@finxone-platform/shared/sys-config-types';
import { Store } from '@ngxs/store';
import { handleRedirection } from '../cta-redirection.utils';

const FEEDBACK_COUNTER_EVENT_NAME = 'app_feedback_counter';

export const trackFeedbackCounter = (injector: Injector, widgetProperties: BaseWidgetProperties): void => {
  const feedbackType = widgetProperties?.['feedbackCounterType'] ?? '';
  const feedbackValue = widgetProperties?.['feedbackCounterValue'] ?? '';
  const includeUserEmail = !!widgetProperties?.['includeUserEmail'];

  if (!feedbackType || !feedbackValue) {
    console.warn('feedback_counter action requires feedbackCounterType and feedbackCounterValue');
    return;
  }

  const { userId, email } = getUserIdentity(injector);

  const googleAnalyticsService = injector.get(GoogleAnalyticsService);

  const gtmPayload: Record<string, unknown> = {
    event: FEEDBACK_COUNTER_EVENT_NAME,
    user_id: userId,
    feedback_type: feedbackType,
    feedback_value: feedbackValue,
    feedback_timestamp: new Date().toISOString(),
  };

  if (includeUserEmail && email) {
    gtmPayload['user_email'] = email;
  }

  googleAnalyticsService?.sendToGoogleTagManager(FEEDBACK_COUNTER_EVENT_NAME, gtmPayload);

  const navigationConfig =
    widgetProperties?.actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS];

  if (!navigationConfig || navigationConfig?.selectedNavigationOption === NavigationOptionEnum.USE_AS_BLANK) {
    console.warn(
      'No navigation configured for feedback counter action or navigation option is set to USE_AS_BLANK. Only tracking event will be performed.',
    );
    return;
  }

  handleRedirection(
    widgetProperties,
    injector,
    ActionButtonOutcomesType.SUCCESS,
    false,
    false,
    ButtonActionType.FEEDBACK_COUNTER,
  );
};

const getUserIdentity = (injector: Injector): { userId: string; email: string } => {
  const store = injector.get(Store);
  const profile = store.selectSnapshot(ProfileState.getProfile);
  return {
    userId: profile?.id ?? '',
    email: profile?.email ?? '',
  };
};
